export class WindowsOpenRequest {
  urls: string[];
}
